import React, { useEffect, useState } from 'react';

import Select from 'react-select';

import {
  Checkbox,
  StructuredListWrapper,
  StructuredListHead,
  StructuredListRow,
  StructuredListCell,
  StructuredListBody,

} from '@carbon/react';

import { useGetGroupsQuery } from 'services/groups';

import './_overrides.scss';

const customStyles = {
  option: (provided, _state) => {
    return {
      ...provided,
    }
  },
  container: (provided, _state) => ({
    ...provided,
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  control: (provided, _state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    borderRadius: 0,
    border: 0,
    backgroundColor: "#f4f4f4",
    borderBottom: "1px solid var(--cds-border-strong)",
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  input: (provided, _state) => ({
    ...provided,
  }),
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const backgroundColor = state.data.preSelected ? "hsl(0, 0%, 50%)" : "hsl(0, 0%, 90%)";
    return { ...provided, opacity, transition, backgroundColor};
  },
  multiValueLabel: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const color = state.data.preSelected ? "var(--cds-text-on-color, #fff)": "var(--cds-text-primary, #161616)";
    const fontStyle = state.data.preSelected ? "italic" : "normal";
    return { ...provided, opacity, transition, color, fontStyle };
  }
}

export const SelectableGroups = ({selection = [], onSelectionChange = () => {}, preSelected, inDialog = false}) => {

  const [currentSelection, setSelection] = useState([]);
  const [currentPreSelection, setPreSelection] = useState([]);
  const {data: groups, isLoading} = useGetGroupsQuery();

  useEffect(() => {
    console.info("setting selection:", selection);
    setSelection(selection);
  }, [selection]);

  useEffect(() => {
    console.info("preSelected selection:", preSelected);
    setPreSelection(preSelected);
  }, [preSelected]);

  const handleSelectionChange = (new_selection, action ) => {
    console.info("handleSelectionChange", new_selection, action, currentSelection, currentPreSelection);
    if (action.action === "clear") {
      // remove all
      //setPreSelection([]);
      onSelectionChange([], []);
      return;
    }
    if (action.action === "remove-value") {
      if (action.removedValue.preSelected)  {
        //setPreSelection(currentPreSelection.filter(e => e !== action.removedValue.value));
        onSelectionChange(currentSelection, currentPreSelection.filter(e => e !== action.removedValue.value));
      } else {
        onSelectionChange(currentSelection.filter(e => e !== action.removedValue.value), currentPreSelection);
      }
    } else {
      if (action.action === "select-option") {
        let new_selection_ids = action.option.value;
        onSelectionChange([...currentSelection, new_selection_ids], currentPreSelection);
      } else {
        //let new_selection_ids = new_selection.map(e => e.value);
        //onSelectionChange([...currentSelection, new_selection_ids], currentPreSelection);
      }

    }
  };

  /*useEffect(() => {
    let a = [...(currentSelection || []).map(current_id => {
      if (groups?.data) {
        const f = groups?.data.find(group => current_id === group.model.ID);
        return {label: f.name, value: f.model.ID}
      }
      return null;
    }), ...(preSelected || []).map(current_id => {
      if (groups?.data) {
        const f = groups?.data.find(group => current_id === group.model.ID);
        return {label: f.name, value: f.model.ID}
      }
      return null;
    })];
  }, [groups, preSelected, currentSelection]);*/

  return (
    <Select
      placeholder="Gruppen auswählen"
      isMulti
      noOptionsMessage={() => "Wählen Sie"}
      isDisabled={isLoading}
      isLoading={isLoading}
      styles={customStyles}
      classNamePrefix={"micast-custom-select"}
      onChange={handleSelectionChange}
      options={(groups?.data || []).map(group => { return {label: group.name, value: group.model.ID, preSelected: false} })}
      value={[...(currentSelection || []).map(current_id => {
        if (groups?.data && current_id) {
          //console.info("inside, current_id:", current_id, currentSelection);
          const f = groups?.data.find(group => current_id === group.model.ID);
          return {label: f.name, value: f.model.ID, preSelected: false}
        }
        return null;
      }), ...(currentPreSelection || []).map(current_id => {
        if (groups?.data && current_id) {
          const f = groups?.data.find(group => current_id === group.model.ID);
          return {label: f.name, value: f.model.ID, preSelected: true}
        }
        return null;
      })]
      }
    />
  )
}

const Groups = ({selection = [], onSelectionChange = () => {}}) => {

  const [currentSelection, setSelection] = useState([]);
  const {data: groups, isLoading} = useGetGroupsQuery();

  useEffect(() => {
    setSelection(selection);
  }, [selection]);


  const handleSelectionChange = (id) => {
    setSelection((prev) => {
      if (prev.find(e => e === id)) {
        return prev.filter(e => e !== id);
      }
      return [...prev, id];
    });

  };

  useEffect(() => {
    console.info("currentSelection", currentSelection);
  }, [currentSelection]);


  return (
    <StructuredListWrapper isCondensed isFlush>
      <StructuredListHead>
        <StructuredListRow head>
          <StructuredListCell head>Name</StructuredListCell>
          <StructuredListCell head>Beschreibung</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody>
        {groups?.data?.map((group, key) => (
          <StructuredListRow key={key}>
            <StructuredListCell noWrap>
              <Checkbox
                id={`checkbox_group_selection_${group.model.ID}`}
                labelText={group.name}
                checked={currentSelection.find(e => e === group.model.ID)}
                onChange={() => handleSelectionChange(group.model.ID)}
              />
            </StructuredListCell>
            <StructuredListCell>{group.description}</StructuredListCell>
          </StructuredListRow>
        ))}
      </StructuredListBody>
    </StructuredListWrapper>
  )
}

export default Groups;
